export default "__VITE_ASSET__Cpin_UA3__"